const KEY_PREFIX = 'dt_model_pref_'

export function getModelPref(key, fallback = 'sonnet') {
  try {
    return localStorage.getItem(KEY_PREFIX + key) || fallback
  } catch {
    return fallback
  }
}

export function setModelPref(key, value) {
  try {
    localStorage.setItem(KEY_PREFIX + key, value)
  } catch {}
}
